import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { CalAm, getInitFormData, CalAmBulk } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showPopupModal } from "@widgets/CommonModal";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import { getNoSlip } from "@shared/utils/CommonUtils";
import { global, useMenuStore } from "@shared/libs/Global";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString } from "@shared/utils/DateUtils";
import { RowNode } from "ag-grid-community";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SN_TRA_NGO_REG_002_POP_001 from "../SN_TRA_NGO_REG_002/SN_TRA_NGO_REG_002_POP_001";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_TRA_NGO_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const { menuItems } = useMenuStore();
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const focusKeyRef = useRef<{
    no_nego?: string;
  } | null>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  const [selectedTab, setSelectedTab] = useState("1");
  const [focusedRowData, setFocusedRowData] = useState<any>();

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved = await onSave();
        if (!isSaved) return;
      }
    }

    const selectedFormData = searchRef.current.getFormdata();
    if (selectedFormData.dt_from > selectedFormData.dt_to) {
      await showDialog(
        "alter",
        " 조회기간의 종료일이 시작일보다빠릅니다. 확인 후 다시 조회해주시기 바랍니다."
      );
      return;
    }

    try {
      const params = {
        id: "sn_tra_ngo_reg_002_01",
        params: searchRef.current.getFormdata(),
      };
      setSelectedDocu("");
      setFocusedRowData(0);

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
      });
    } catch (error: any) {}
  };
  const onGrid2BtnClick = async (id: string) => {
    try {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    } catch (error: any) {
      await showDialog("error", error.message);
    }
  };
  const onAddRow = () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const selectedNoNego = focusedNodeH?.data.no_nego;
      const today = dateToString(new Date());
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_nego: selectedNoNego,
        dt_nego: focusedNodeH?.data.dt_nego,
        cd_cust: focusedNodeH?.data.cd_cust,
        fg_trns: focusedNodeH?.data.fg_trns,
        tp_nego: focusedNodeH?.data.tp_nego,
        fg_nego: focusedNodeH?.data.fg_nego,
        cd_exch: focusedNodeH?.data.cd_exch,
        rt_exch_nego: focusedNodeH?.data.rt_exch,
        am_nego: 0,
        am_k_nego: 0,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        cd_biz: userInfo?.cd_biz,
        cd_gp: userInfo?.cd_gp,
        dt_bl: today,
        dt_negos: today,
        yn_docu: "N",
        am: 0,
        am_k: 0,
        am_k_pl: 0,
        rt_exch: 1,
        no_bl: "",
      };
      return gridRefs.current["grid2"].current?.addRow(newRow);
    } catch (error: any) {}
  };
  const onDeleteRow = async () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;
    gridRefs.current["grid2"].current?.deleteSelectedRows();
    onAfterSetFooter();
  };

  const onSave = async () => {
    let negoChanges;
    let negosChanges;
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) return false;
      negoChanges = gridRefs.current["grid1"].current.getChange();
      negosChanges = gridRefs.current["grid2"].current.getChange();
      const headerInserts = negoChanges.insert ?? [];
      const lineInserts = negosChanges.insert ?? [];
      if (
        negoChanges.modifiedRowcount === 0 &&
        negosChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }
      if (lineInserts.length !== 0) {
        const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();
        const slipDate =
          headerInserts[0]?.dt_nego || focusedRow?.data?.dt_nego || "";

        for (const row of lineInserts) {
          if (row.no_negos) continue;

          const noSlip = await getNoSlip(
            Menuprops.cd_module || "TRA",
            1,
            "NGO",
            slipDate,
            Menuprops.cd_menu
          );

          if (!noSlip) {
            await showDialog("error", "전표채번에 실패했습니다.");
            return false;
          }

          row.no_negos = noSlip;
        }
      }

      const saveData = {
        nego: negoChanges,
        negos: negosChanges,
      };

      const ok = await fnSave("SN_TRA_NGO_REG_002_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();

      const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();

      if (focusedRow) {
        focusKeyRef.current = {
          no_nego: focusedRow.data.no_nego,
        };
      }
      await onSearch();

      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid3"].current.resetUpdate(true);
      return false;
    }
  };

  const onFocusedRowChanged = async (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_nego = selectedRow.no_nego;
      gridRefs.current["grid2"].current.applyFilters({
        no_nego: no_nego,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  const onCellValueChangedL = async (event: any) => {
    if (!event) return;
    const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "am") {
      rowNode.setDataValue("am_nego", rowData.am, "noEvent");
      rowNode.setDataValue(
        "am_k_nego",
        rowData.rt_exch_nego * rowData.am_nego,
        "noEvent"
      );
      rowNode.setDataValue("am_k", rowData.rt_exch * rowData.am, "noEvent");
      rowNode.setDataValue(
        "am_k_pl",
        (focusedRow.data.rt_exch - rowData.rt_exch) * rowData.am,
        "noEvent"
      );
    }

    // CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };
  const onCellDoubleClicked = async (event: any) => {
    const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();
    if (event.colDef.field === "no_bl") {
      const component = (
        <SN_TRA_NGO_REG_002_POP_001
          selectedData={{
            cd_cust: focusedRow?.data?.cd_cust || "",
            nm_cust: focusedRow?.data?.nm_cust || "",
          }}
        />
      );
      const result = await showPopupModal({
        title: "B/L적용",
        children: component,
        width: "80%",
      });
      if (!result || result === "close") return;
      const headerResult = result[0];
      const lineResult: any[] = result[1];
      setTimeout(() => {
        const selectedAmount = Number(lineResult[0]["am_c"]) || 0;
        const currentRowAmount = Number(event.node.data.am) || 0;
        const footerAmount =
          Number(gridRefs.current["grid2"].current.getFooterData()?.am) || 0;
        const availableAmount =
          (Number(focusedRow.data.am) || 0) - footerAmount + currentRowAmount;
        const applyAmount = Math.max(
          0,
          Math.min(selectedAmount, availableAmount)
        );
        event.node.setDataValue("no_bl", lineResult[0]["no_sales"], "noEvent");
        event.node.setDataValue("rt_exch", lineResult[0]["rt_exch"], "noEvent");
        event.node.setDataValue("am", applyAmount);
      }, 0);
      gridRefs.current["grid2"].current?.stopEditing();
    }
  };
  const onAfterSetFooter = () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const footerData = gridRefs.current["grid2"].current.getFooterData();
    if (focusedNodeH) {
      focusedNodeH.setDataValue(
        "am_balance",
        focusedNodeH.data.am - footerData.am
      );
      focusedNodeH.setDataValue("am_target", footerData.am);
      focusedNodeH.setDataValue("am_k_target", footerData.am_k);
      focusedNodeH.setDataValue("am_k_pl", footerData.am_k_pl);
    }
  };
  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_nego === focusKey.no_nego) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onBtnAddClick: onGrid2BtnClick,
          onBtnDeleteClick: onGrid2BtnClick,
          onCellDoubleClicked: onCellDoubleClicked,
          onAfterSetFooter: onAfterSetFooter,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "NEGO등록",
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "NEGO정리",
            }}
            events={grids.grid2.events}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
});

export default SN_TRA_NGO_REG_002;
